import type { UseQueryResult } from '@tanstack/react-query';
import { useBffGet } from '../bff';
import { BffQueryKey } from '../model/BffQueryKey';
import type { BulkProductSummary } from './model';

export const useBulkProductsSummary = (
    skus: string,
): UseQueryResult<BulkProductSummary[], unknown> =>
    useBffGet<BulkProductSummary[]>(
        skus ? '/turn-to/bulk-summary' : null,
        [{ skus }],
        [BffQueryKey.TURN_TO_BULK_SUMMARY],
        { enabled: false },
    );
